    <mat-toolbar style="background-image: linear-gradient( 109.6deg,  rgba(61,131,97,1) 11.2%, rgba(28,103,88,1) 91.1% );">  
      <mat-menu #mymenu="matMenu">     
            <div *ngFor="let item of menuItems">  
                <button mat-button *ngIf="item.showOnMobile"
                    [routerLink]="item.routerlink" routerLinkActive="active">
                    <mat-icon class="mr">{{item.icon}}</mat-icon>
                    {{item.label}}
                </button>
            </div> 
      </mat-menu>    
      <div  *ngFor="let item of menuItems" fxHide fxShow.gt-sm >  
        <button mat-button color="success" *ngIf="!isMobile"
            [routerLink]="item.routerlink" routerLinkActive="active">
            <mat-icon class="mr">{{item.icon}}</mat-icon>
            {{item.label}}
        </button>
    </div> 
     
    </mat-toolbar> 
 